var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-row",
    [
      _c(
        "w-col",
        { attrs: { xs: "12" } },
        [
          _c("w-input", {
            attrs: { fancy: "", label: _vm.$ct("labels.title") },
            model: {
              value: _vm.event.event.summary,
              callback: function ($$v) {
                _vm.$set(_vm.event.event, "summary", $$v)
              },
              expression: "event.event.summary",
            },
          }),
        ],
        1
      ),
      _c(
        "w-col",
        { attrs: { xs: "12" } },
        [
          _c("w-input-autocomplete", {
            attrs: {
              value: _vm.event.event.location,
              label: _vm.$ct("labels.location"),
              fancy: "",
              items: _vm.locationItems,
              icon: _vm.event.event.location ? "map-marked-alt" : "",
              "icon-tooltip": _vm.$ct("labels.show-on-map"),
            },
            on: {
              "icon-click": function ($event) {
                return _vm.openMap()
              },
              input: function ($event) {
                return _vm.setLocation($event)
              },
              blur: function ($event) {
                _vm.locationResults = []
              },
              "item-click": function ($event) {
                return _vm.onLocationClicked($event)
              },
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (slotProps) {
                  return [_c("div", [_vm._v(_vm._s(slotProps.item.text))])]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c(
        "w-col",
        { attrs: { xs: "12" } },
        [
          _vm.editingDescription
            ? _c("w-textarea-autogrow", {
                attrs: {
                  value: _vm.event.event.description,
                  fancy: "",
                  label: _vm.$ct("labels.description"),
                },
                on: {
                  input: function ($event) {
                    return _vm.$set(_vm.event.event, "description", $event)
                  },
                },
              })
            : _c(
                "div",
                {
                  directives: [
                    {
                      name: "tooltip",
                      rawName: "v-tooltip",
                      value: _vm.$ct("edit-description"),
                      expression: "$ct('edit-description')",
                    },
                  ],
                  staticClass: "description-view",
                  on: {
                    click: function ($event) {
                      _vm.editingDescription = true
                    },
                  },
                },
                [
                  _c("div", { staticClass: "description-label" }, [
                    _vm._v(_vm._s(_vm.$ct("labels.description"))),
                  ]),
                  _c("div", {
                    directives: [
                      {
                        name: "safe-html",
                        rawName: "v-safe-html",
                        value: _vm.event.event.description,
                        expression: "event.event.description",
                      },
                    ],
                    staticClass: "description-html",
                  }),
                ]
              ),
        ],
        1
      ),
      _c("app-date-time-edit", {
        attrs: {
          "label-date": _vm.$ct("labels.start"),
          "label-time": _vm.$ct("labels.start-time"),
          "hide-time-picker": _vm.allDay,
        },
        on: {
          input: function ($event) {
            return _vm.onStartInput($event)
          },
        },
        model: {
          value: _vm.startTime,
          callback: function ($$v) {
            _vm.startTime = $$v
          },
          expression: "startTime",
        },
      }),
      _c("app-date-time-edit", {
        attrs: {
          "label-date": _vm.$ct("labels.end"),
          "label-time": _vm.$ct("labels.end-time"),
          "hide-time-picker": _vm.allDay,
        },
        on: {
          input: function ($event) {
            return _vm.onEndInput($event)
          },
        },
        model: {
          value: _vm.endTime,
          callback: function ($$v) {
            _vm.endTime = $$v
          },
          expression: "endTime",
        },
      }),
      _c(
        "w-col",
        { attrs: { xs: "12" } },
        [
          _c(
            "w-col",
            [
              _c("w-checkbox", {
                attrs: { label: _vm.$ct("labels.all-day") },
                model: {
                  value: _vm.allDay,
                  callback: function ($$v) {
                    _vm.allDay = $$v
                  },
                  expression: "allDay",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("w-divider"),
      _c(
        "w-col",
        { attrs: { xs: "12" } },
        [
          _vm._l(_vm.reminders, function (reminder, i) {
            return _c("google-calendar-reminder", {
              key: i,
              attrs: { reminder: reminder },
              on: {
                remove: function ($event) {
                  return _vm.removeReminder(i)
                },
              },
            })
          }),
          _c(
            "w-row",
            [
              _c(
                "w-link",
                { staticClass: "mt", on: { click: _vm.addReminder } },
                [
                  _c("w-fa", { staticClass: "mrs", attrs: { icon: "plus" } }),
                  _vm._v(" " + _vm._s(_vm.$ct("reminders.add")) + " "),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c("w-divider"),
      _c(
        "w-col",
        { attrs: { xs: "12" } },
        [
          _c("w-select", {
            attrs: {
              items: _vm.calendarItems,
              fancy: "",
              label: _vm.$ct("labels.calendar"),
            },
            model: {
              value: _vm.event.calendarId,
              callback: function ($$v) {
                _vm.$set(_vm.event, "calendarId", $$v)
              },
              expression: "event.calendarId",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }